import * as React from "react";
export default function CenteredHeadingSeparator() {
  return;
}